import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ErrorsHostDirective } from '@app/core/forms/directives/errors-host.directive';
import { IfInvalidDirective } from '@app/core/forms/directives/if-invalid.directive';
import { hasLowercaseLetterValidator } from '@app/core/forms/validators/has-lowercase-letter';
import { hasNumberValidator } from '@app/core/forms/validators/has-number';
import { hasUppercaseLetterValidator } from '@app/core/forms/validators/has-uppercase-letter';
import { CustomValidators } from 'ng2-validation';

@Component({
  selector: 'app-new-password',
  templateUrl: './new-password.component.html',
  styleUrls: ['./new-password.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IfInvalidDirective,
    ErrorsHostDirective,
    FormsModule,
    ReactiveFormsModule,
  ],
})
export class NewPasswordComponent implements OnInit {
  @Input()
  passwordLabel: string = '';

  @Input()
  confirmPasswordLabel: string = '';

  passwordFC!: FormControl;
  confirmPasswordFC!: FormControl;

  constructor(private formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this.initFormControls();
  }

  private initFormControls(): void {
    this.passwordFC = this.formBuilder.control(null, [
      Validators.required,
      Validators.minLength(8),
      Validators.maxLength(30),
      hasUppercaseLetterValidator(),
      hasLowercaseLetterValidator(),
      hasNumberValidator(),
    ]);

    this.confirmPasswordFC = this.formBuilder.control(null, [
      Validators.required,
      CustomValidators.equalTo(this.passwordFC),
    ]);
  }
}
